/* eslint-disable @typescript-eslint/no-explicit-any */
import { IApplicationState } from '../../types/redux';
import { IInteriorDecoration } from '../../types/newbuilding/decoration';

export function getInteriorDecoration(state: IApplicationState): IInteriorDecoration[] {
  const items = state.newbuilding.interiorDecoration;

  return (items as any).filter(({ images }: any) => images.length);
}
